module.exports = __webpack_public_path__ + "img/03-illu-matome2021.630d3782.png";